<template>
  <div class="container">
    <div class="person-router">
      <div class="title">推廣路線</div>
      <div class="people" v-for="(item, index) in userInfo" :key="index">
        <div class="item" v-if="index <= certification_type">
          <div class="arrow-down" v-if="index > 0"></div>
          <div class="person">
            <div class="avatar">
              <img :src="item.avatar" />
            </div>
            <div class="info">
              <div class="nickname">暱稱：{{ item.nickname }}</div>
              <div class="id">ID：{{ item.uid }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getPromoterRoute } from "@api/user";
export default {
  name: "PromoteRouter",
  components: {},
  data: function() {
    return {
      userInfo: {},
      certification_type: 0
    };
  },
  watch: {},
  created() {
    this.certification_type = this.$route.query.certification_type;
  },
  async mounted() {
    let routes = await getPromoterRoute(this.$route.query.uid);
    this.userInfo = routes.data;
    console.log(this.userInfo);
  },
  methods: {}
};
</script>
<style scoped>
.container {
  padding: 15px;
  height: 100%;
}
.person-router {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  height: 100%;
  border-radius: 4px;
  overflow: auto;
}
.person-router .title {
  font-size: 1rem;
  margin-bottom: 10px;
}
.person-router .people .arrow-down {
  width: 1px;
  height: 0.7rem;
  margin: 0.15rem 0;
  background-color: red;
  position: relative;
}
.person-router .people .arrow-down:before {
  content: "";
  width: 10px;
  height: 10px;
  border-right: 1px red solid;
  border-bottom: 1px red solid;
  position: absolute;
  transform: rotate(45deg);
  bottom: 0;
  left: -4px;
}
.person-router .people .item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.person-router .people .item .person {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.5rem;
}
.person-router .people .item .person .avatar {
  width: 1.6rem;
  height: 1.6rem;
}
.person-router .people .item .person .avatar img {
  width: 100%;
  height: 100%;
}
</style>
